import { essentialLocales, baseLocales } from '@fs/zion-locale'

const manuallyAddedLocales = ['eo']
export const appSupportedLocales = [...essentialLocales, ...baseLocales, ...manuallyAddedLocales]

const notSupportedS3Locales = ['ceb', 'fj', 'ti', 'uk', 'mg', 'ms', 'et', 'hr', 'lv', 'tl']
const supportedEssentialLocales = essentialLocales.filter((locale) => !notSupportedS3Locales.includes(locale))
// These are the ones that are found in the localized data from what the backend give us
export const searchSupportedLocales = [...baseLocales, ...supportedEssentialLocales]
